import React from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkOrderItems } from "../../data/WorkItemHook";

function DisconnectionWorkItemEdit() {
  const workItemsRepository = useWorkOrderItems();

  const updateJobSpecificAccessNotes = (e) => {
    const current = workItemsRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workItemsRepository.setEntry(revised);
  };

  const workItem = workItemsRepository.getEntry();

  const handleSuppliesToDisconnectChange = (e) => {
    const current = workItemsRepository.getEntry();
    const revised = { ...current, [e.target.id]: !current[e.target.id] };
    workItemsRepository.setEntry(revised);
  };

  return (
    <Container className="work-order-item-container">
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="suppliesToDisconnect">
            <Form.Label>Supplies To Disconnect</Form.Label>
            <Form.Check
              type="checkbox"
              id="disconnectelectricity"
              label="Disconnect Electricity"
              checked={workItem.disconnectelectricity}
              onChange={handleSuppliesToDisconnectChange}
            />
            <Form.Check
              type="checkbox"
              id="disconnectheat"
              label="Disconnect Heat"
              checked={workItem.disconnectheat}
              onChange={handleSuppliesToDisconnectChange}
            />
            <Form.Check
              type="checkbox"
              id="disconnecthotwater"
              label="Disconnect Hot Water"
              checked={workItem.disconnecthotwater}
              onChange={handleSuppliesToDisconnectChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
            <Form.Label>Job Specific Access Notes</Form.Label>
            <Form.Control
              as="input"
              value={workItem.jobSpecificAccessNotes}
              onChange={updateJobSpecificAccessNotes}
            />
          </Form.Group>
        </Col>
      </Row>
    </Container>
  );
}

export default DisconnectionWorkItemEdit;
